export default __webpack_public_path__ + "static/media/icon_nobuildings.4c6ed55d.svg";